import React from 'react'
import './index.scss'
import { connect } from 'react-redux'
const matStateToProps = (state) => ({
    tenant: state.getIn(['tenantReducer', 'tenant']),
})
// 条款隐私确认
function PrivacyPolicy(props) {
    let cxname = props.tenant
    let { history } = props
    // const handleAgreeBtn = () => {
    //     console.log('AGREE')
    // }
    // const handleRejectBtn = () => {
    //     console.log('REJECT')
    // }

    // 协议跳转
    const handleGoPrivacy = () => {
        history.push('/privacytext');
    }
    const handleGoService = () => {
        history.push('/service');
    }
    return (
        <div className="privacy__box">
            <section className="privacy-con__box">
                <h2>服务条款和隐私协议</h2>
                <div className="privacy-con__show">
                    温馨提示   感谢您信任并使用{cxname}！我们依据最新法律法规、监管政策要求及业务实际情况，更新了<span style={{ color: `${React.colorConfig ? React.colorConfig.mainColor : '#FFA43C'}` }} onClick={handleGoPrivacy}>{`《${cxname}隐私协议》`}</span><span style={{ color: `${React.colorConfig ? React.colorConfig.mainColor : '#FFA43C'}` }} onClick={handleGoService}>{`《${cxname}服务协议》`}</span>，特此向您推送本提示。
                    <div>
                    请您务必仔细阅读并透彻理解相关条款内容，在确认充分理解并同意后使用{cxname}司机相关产品或服务。点击同意即代表您已阅读并同意 《 用户服务协议 》 、 《 隐私政策 》 ，如果您不同意，将有可能影响使用{cxname}司机的产品和服务。我们将按法律法规要求，采取相应安全，保护措施，尽力保护您的个人信息安全可控。
                    </div>
                </div>
                {/* <div className="btn__box">
                    <button onClick={handleRejectBtn}>不同意</button>
                    <button onClick={handleAgreeBtn}>同意</button>
                </div> */}
            </section>
        </div>
    )

}
export default connect(matStateToProps)(PrivacyPolicy)
